// Imports for external libraries go here.
import React, { FC, Fragment, memo } from 'react';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { useAuthStore } from '../../store';
import { useTrackingPreferenceModal } from '../../hooks/useTrackingPreferenceModal';

import { LegalTextWithLink } from '../LegalTextWithLink';

import { DoNotSellShareComponent } from './DoNotSellShareComponent';
import { PrivacyRightsComponentProps } from './PrivacyRightsComponent.types';
import { StyledPrivacyRightsComponent } from './PrivacyRightsComponent.styles';

// Use named rather than default exports.
export const PrivacyRightsComponent: FC<PrivacyRightsComponentProps> = memo(
  ({ statesData, selectedStateOrLoggedInUserStateCode, stateNameSuffix }) => {
    const isAuth = useAuthStore(state => state.isAuthenticated);

    // Below data will be fetched from AEM model.json
    useTrackingPreferenceModal(
      selectedStateOrLoggedInUserStateCode!,
      'js-tracking-pref',
      'ot-sdk-btn',
      'close-pc-btn-handler'
    );

    const currentState = statesData.find(s => s.stateCode === selectedStateOrLoggedInUserStateCode);
    if (!currentState) {
      throw new Error(`Invalid State Code: ${selectedStateOrLoggedInUserStateCode}`);
    }
    const {
      [isAuth ? 'stateAuthContent' : 'stateUnAuthContent']: { doNotSellShareSections, additionalSection },
      stateName,
    } = currentState;

    return (
      <StyledPrivacyRightsComponent
        data-testid="legal-PrivacyRightsComponent"
        data-component-name="m-legal-PrivacyRightsComponent"
      >
        {isAuth && (
          <>
            <h3 data-testid="legal-privacyRights-stateName">{`${stateName} ${stateNameSuffix}`}</h3>
            <hr />
          </>
        )}
        {doNotSellShareSections?.map((doNotSellShareData, index) => (
          <Fragment key={doNotSellShareData.uniqueId}>
            <DoNotSellShareComponent {...doNotSellShareData} />
            {doNotSellShareSections.length > 1 && index < doNotSellShareSections.length - 1 && <hr />}
          </Fragment>
        ))}
        {additionalSection && (
          <>
            <hr />
            <LegalTextWithLink descriptionText={additionalSection} testId="privacy-Rights-Additional-Section" />
          </>
        )}
      </StyledPrivacyRightsComponent>
    );
  }
);
